
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M3.5 8.5h6.77c.897 0 1.758-.369 2.393-1.025A3.561 3.561 0 0 0 13.652 5c0-.928-.356-1.818-.99-2.475A3.329 3.329 0 0 0 10.268 1.5H3.5v7Zm0 0h7.615a3.33 3.33 0 0 1 2.394 1.025c.634.656.991 1.547.991 2.475 0 .928-.357 1.819-.991 2.475a3.33 3.33 0 0 1-2.394 1.025H3.5v-7Z","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    